import type { LucideIcon } from 'lucide-react';
import {
  BookOpen,
  Video,
  FileText,
  ClipboardCheck,
  GraduationCap,
  Layers,
  Sparkles,
  Code2,
  Presentation,
  Target,
  Lightbulb,
  Rocket,
  BarChart3,
  Users,
  Zap,
  Globe,
  Mail,
  MessageSquare,
  PenTool,
  Mic2,
  Camera,
  Music,
  Gamepad2,
  Palette,
  Wrench,
  Beaker,
  Leaf,
  Heart,
  Shield,
  Award,
  TrendingUp,
} from 'lucide-react';

export const MODULE_ICON_OPTIONS: { value: string; label: string; Icon: LucideIcon; colorClass: string }[] = [
  { value: 'book-open', label: 'Book', Icon: BookOpen, colorClass: 'text-africa-blue' },
  { value: 'video', label: 'Video', Icon: Video, colorClass: 'text-africa-red' },
  { value: 'file-text', label: 'Document', Icon: FileText, colorClass: 'text-africa-green' },
  { value: 'clipboard-check', label: 'Checklist', Icon: ClipboardCheck, colorClass: 'text-africa-purple' },
  { value: 'graduation-cap', label: 'Graduation', Icon: GraduationCap, colorClass: 'text-africa-orange' },
  { value: 'layers', label: 'Layers', Icon: Layers, colorClass: 'text-africa-yellow' },
  { value: 'sparkles', label: 'Sparkles', Icon: Sparkles, colorClass: 'text-accent' },
  { value: 'code-2', label: 'Code', Icon: Code2, colorClass: 'text-africa-blue' },
  { value: 'presentation', label: 'Presentation', Icon: Presentation, colorClass: 'text-africa-green' },
  { value: 'target', label: 'Target', Icon: Target, colorClass: 'text-primary' },
  { value: 'lightbulb', label: 'Idea', Icon: Lightbulb, colorClass: 'text-africa-yellow' },
  { value: 'rocket', label: 'Launch', Icon: Rocket, colorClass: 'text-africa-orange' },
  { value: 'bar-chart-3', label: 'Analytics', Icon: BarChart3, colorClass: 'text-africa-green' },
  { value: 'users', label: 'Team', Icon: Users, colorClass: 'text-africa-blue' },
  { value: 'zap', label: 'Energy', Icon: Zap, colorClass: 'text-accent' },
  { value: 'globe', label: 'Global', Icon: Globe, colorClass: 'text-africa-green' },
  { value: 'mail', label: 'Email', Icon: Mail, colorClass: 'text-africa-red' },
  { value: 'message-square', label: 'Chat', Icon: MessageSquare, colorClass: 'text-africa-purple' },
  { value: 'pen-tool', label: 'Write', Icon: PenTool, colorClass: 'text-primary' },
  { value: 'mic-2', label: 'Audio', Icon: Mic2, colorClass: 'text-africa-orange' },
  { value: 'camera', label: 'Camera', Icon: Camera, colorClass: 'text-africa-red' },
  { value: 'music', label: 'Music', Icon: Music, colorClass: 'text-africa-purple' },
  { value: 'gamepad-2', label: 'Game', Icon: Gamepad2, colorClass: 'text-africa-green' },
  { value: 'palette', label: 'Design', Icon: Palette, colorClass: 'text-africa-yellow' },
  { value: 'wrench', label: 'Tools', Icon: Wrench, colorClass: 'text-primary' },
  { value: 'beaker', label: 'Lab', Icon: Beaker, colorClass: 'text-africa-blue' },
  { value: 'leaf', label: 'Eco', Icon: Leaf, colorClass: 'text-africa-green' },
  { value: 'heart', label: 'Health', Icon: Heart, colorClass: 'text-africa-red' },
  { value: 'shield', label: 'Security', Icon: Shield, colorClass: 'text-africa-purple' },
  { value: 'award', label: 'Award', Icon: Award, colorClass: 'text-accent' },
  { value: 'trending-up', label: 'Growth', Icon: TrendingUp, colorClass: 'text-africa-green' },
];

const iconMap = new Map<string, LucideIcon>(
  MODULE_ICON_OPTIONS.map((o) => [o.value, o.Icon])
);

const defaultIcon = BookOpen;

/** Resolve a stored icon key (e.g. from API) to a Lucide icon component. */
export function getModuleIcon(iconKey: string | null | undefined): LucideIcon {
  if (!iconKey || !iconKey.trim()) return defaultIcon;
  return iconMap.get(iconKey.trim()) ?? defaultIcon;
}

/** Get color class for an icon key (for picker/cards). */
export function getModuleIconColor(iconKey: string | null | undefined): string {
  const opt = MODULE_ICON_OPTIONS.find((o) => o.value === (iconKey?.trim() ?? ''));
  return opt?.colorClass ?? 'text-muted-foreground';
}
